import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { EmptyState, Icon } from "@sx/ui";
import { queryPolicies } from "@sx/api-client";

import { Region } from "../../../components/Region";
import { organizations } from "../../../lib/account";
import { RouteFallback } from "../../../shell/RouteFallback";
import {
  DeleteOrganizationCard,
  OrganizationPanel,
} from "../../../workspaces/settings/OrganizationPanel";
import { OrganizationProjectsPanel } from "../../../workspaces/settings/ProjectsPanel";
import { useAuthQueryKey } from "../../../lib/query-keys";

export const Route = createFileRoute("/_console/settings/organizations/$organizationId")({
  component: OrganizationSettingsRoute,
});

function OrganizationSettingsRoute() {
  const key = useAuthQueryKey();
  const { organizationId } = Route.useParams();
  const rows = useQuery({
    queryKey: key("organizations"),
    queryFn: organizations,
    ...queryPolicies.reference,
  });
  return (
    <Region
      query={rows}
      title="Organizations"
      placeholder={
        <RouteFallback />
      }
    >
      {(organizationRows) => {
        const organization = organizationRows.find((row) => row.id === organizationId);
        if (!organization) {
          return (
            <EmptyState
              icon={<Icon name="organization" />}
              title="Organization unavailable"
              hint="Choose an organization from the avatar menu."
            />
          );
        }
        return (
          <div className="space-y-5">
            <OrganizationPanel organization={organization} />
            <OrganizationProjectsPanel organization={organization} />
            <DeleteOrganizationCard organization={organization} />
          </div>
        );
      }}
    </Region>
  );
}
